export function maskString(value) {
  if (typeof value !== 'string') return '';

  if (value.length <= 1) return value;

  const visibleStart = value.charAt(0);
  const masked = '*'.repeat(value.length - 1);

  return `${visibleStart}${masked}`;
}
